<template>
    <svg width="8" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l5.293 5.293a1 1 0 010 1.414L1 13" stroke="var(--color-primary)" stroke-width="1.5" stroke-linecap="round"/></svg>
</template>
<script>
export default {
    computed: {
        colorPrimary() {
            return getComputedStyle(document.documentElement).getPropertyValue('--color-primary')
        }
    }
}
</script>